import { parseAsString, useQueryStates } from '@vrplatform/query-params';
import { day } from '@vrplatform/utils';

export function useTrustReconciliationByListingTableFilter() {
  const [filter, setFilter] = useQueryStates({
    endDate: parseAsString,
  });

  return {
    filter: {
      ...filter,
      endDate:
        filter.endDate && day(filter.endDate).isValid()
          ? day(filter.endDate).yyyymmdd()
          : day().yyyymmdd(),
    },
    setFilter,
  };
}
